import { EventEmitter } from 'events';
import assign from 'object-assign';
import AdminAppDispatcher from 'dispatcher/AdminAppDispatcher';
import AdminConstants from 'constants/AdminConstants';

const ActionTypes = AdminConstants.ActionTypes;

const CHANGE_EVENT = 'change';
let downloaded = false;

const OrdersCsvStore = assign({}, EventEmitter.prototype, {
  addChangeListener(callback) {
    this.on(CHANGE_EVENT, callback);
  },

  removeChangeListener(callback) {
    this.removeListener(CHANGE_EVENT, callback);
  },

  emitChange() {
    this.emit(CHANGE_EVENT);
  },

  isFileDownloaded() {
    return downloaded;
  },
});

AdminAppDispatcher.register((payload) => {
  switch (payload.action.type) {
    case ActionTypes.DOWNLOAD_ORDERS_CSV:
      downloaded = false;
      OrdersCsvStore.emitChange();
      break;
    case ActionTypes.DOWNLOAD_ORDERS_CSV_SUCCESS:
      downloaded = true;
      OrdersCsvStore.emitChange();
      break;
    default:
  }
});

export default OrdersCsvStore;
